<template>
  <div class="messages">
    <div class="title">
      <span></span>消息中心
    </div>
    <div
      class="msg_content infinite-list"
      ref="scrollList"
      v-infinite-scroll="pushnext"
      infinite-scroll-disabled="isquestionall"
      infinite-scroll-distance="10"
      infinite-scroll-immediate="false"
    >
      <div class="msglist" v-for="(bitem,bindex) in newnoticesArr" :key="bindex">
        <p class="index_time" v-show="bindex.length>0">{{bindex}}</p>
        <div class="msgli" v-for="(item,index) in bitem.data" :key="index" v-show="bindex.length>0">
          <div class="delete_icon" @click="delete_item(bindex,index,item)"></div>
          <div class="msg_li" @click="goquestion(item)">
            <p class="msg_title">
              {{item.from_user_name}}&nbsp;
              <span v-if="item.type==1">回答了你的问题</span>
              <span v-if="item.type==2||item.type==3">评论了你的回答</span>
              <span class="send_time">{{item.send_time}}</span>
            </p>
            <p class="question_title">{{item.question_title}}</p>
            <p class="msg_comment" v-if="item.type == 2">
              <span></span>
              {{item.comment_content}}
            </p>
            <p class="msg_comment" v-if="item.type == 3">
              <span></span>评论已删除
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {addstamp} from '../../util/stamp';
import { distance } from "../../util/reset_time";
export default {
  data() {
    return {
      userid: null,
      currentpage: 1,
      noticesArr: [],
      newnoticesArr: [],
      total_pages: 1
    };
  },
  created() {
    this.userid = parseInt(this.$store.state.user_id);
    this.loadmessage();
  },
  mounted() {},
  methods: {
    pushnext() {
      if (this.currentpage != this.total_pages) {
        this.currentpage += 1;
        this.loadmessage();
      }
    },
    loadmessage() {
      let that = this;
      let params = {
        user_id: this.userid,
        page: this.currentpage,
        page_size: 10,
        type:'page'
      };
      var sign = addstamp(params)
      delete params.token
      params['sign'] = sign
      let url = "community/notices/" + this.userid;
      this.$axios.get(url, { params }).then(function(res) {
        // console.log(res);
        that.currentpage = res.data.data.current_page;
        that.total_pages = res.data.data.total_pages;
        if (that.currentpage == 1) {
          that.noticesArr = res.data.data.notices;
        } else {
          that.noticesArr = that.noticesArr.concat(res.data.data.notices);
        }
        that.newnoticesArr = {};
        for (var i = 0; i < that.noticesArr.length; i++) {
            var item = that.noticesArr[i];
            that.groupByMonth(item);
        }
      });
    },
    groupByMonth(value) {
      var date = this.dateFormat(value.send_time * 1000);
      // var key = date.year + '_' + date.month+"_"+date.day
      if (typeof value.send_time == "number") {
        var key = distance(value.send_time);
      } else {
        var key = value.send_time;
      }
      var nowyear = date.year;
      var nowmonth = date.month;
      var dict = this.newnoticesArr[key];
      if (!dict) {
        dict = {};
        this.newnoticesArr[key] = dict;
      }
      if (!dict.data) {
        dict.data = [];
      }
      //   var time = distance(value.send_time);
      value.send_time = key;
      //   console.log(value)
      dict.data.push(value);
    },
    // 格式化
    dateFormat(_timestamp) {
      var date = _timestamp ? new Date(_timestamp) : new Date();
      return {
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate(),
        hour: date.getHours(),
        minutes: date.getMinutes(),
        second: date.getSeconds()
      };
    },
    delete_item(bindex, index, item) {
      let that = this;
      var params = {
        user_id: this.userid,
        notice_id:item.notice_id
      };
      var sign = addstamp(params)
      delete params.token
      params['sign'] = sign
      var url = "community/notice/" + item.notice_id;
      this.$axios.delete(url, { params }).then(function(res) {
        if (res.data.data) {
            that.currentpage = 1
            that.loadmessage()
        }
      });
    },
    goquestion(item) {
      if(item.type != 3){
        this.$router.push({
          path: "/questionDetails",
          query: {
            qd: item.question_id,
            a: 2,
            nd: item.notice_id
          }
        });
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.messages {
  width: 1200px;
  margin: 0 auto;
  margin-bottom: 72px;
  .title {
    width: 170px;
    height: 30px;
    color: #d55d3a;
    font-size: 18px;
    margin-top: 15px;
    margin-bottom: 15px;
    cursor: pointer;
    span {
      display: inline-block;
      width: 30px;
      height: 30px;
      background: url(../../assets/message/mes_icon@2x.png) center center
        no-repeat;
      background-size: cover;
      vertical-align: middle;
      margin-right: 5px;
    }
  }
  .msg_content {
    width: 100%;
    background: #fff;
    cursor: pointer;
    padding-bottom: 45px;
    .msglist {
      width: 100%;
      box-sizing: border-box;
      .index_time {
        width: 100%;
        height: 60px;
        font-size: 18px;
        font-family: PingFang SC;
        font-weight: 600;
        line-height: 60px;
        padding-left: 44px;
        box-sizing: border-box;
      }
    }
    .msgli {
      width: 100%;
      height: 100%;
      position: relative;
      padding: 0px 42px;
      box-sizing: border-box;
      // border-bottom: 1px solid #DCDCDC;
      .delete_icon {
        width: 13px;
        height: 13px;
        background: url(../../assets/message/delete_icon@2x.png) no-repeat
          center center;
        background: cover;
        position: absolute;
        top: 24px;
        right: 32px;
        z-index: 999;
        display: none;
        // border: 1px solid red;
      }
      &:hover {
        background: #f5efeb;
        .delete_icon {
          display: block;
        }
        .msg_li {
          border-bottom: 1px solid #f5efeb;
        }
      }
    }
    .msg_li {
      width: 100%;
      margin: 0 auto;
      box-sizing: border-box;
      padding: 21px 0px;
      border-bottom: 1px solid #dcdcdc;
      .msg_title {
        color: #999;
        .send_time {
          margin-left: 30px;
        }
      }
      .question_title {
        font-family: PingFang SC;
        font-weight: 600;
        color: rgba(51, 51, 51, 1);
        margin-top: 18px;
      }
      .msg_comment {
        margin-top: 20px;
        color: #999;
        span {
          display: inline-block;
          margin-left: 10px;
          margin-right: 5px;
          width: 5px;
          height: 18px;
          background: #aaa;
          vertical-align: bottom;
          text-align: center;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/page/messagecenter.vue